import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { ChatStore } from './Chat.types'
import { immer } from 'zustand/middleware/immer'

const chatStoreInitialState: Omit<ChatStore, 'resetStore' | 'updateValue'> = {
  openInboxDrawer: false,
  hasUnreadMessages: false,
  initChatProvider: false,
}

export const useChatStore = create(
  immer(
    persist<ChatStore>(
      set => ({
        ...chatStoreInitialState,
        resetStore() {
          set(() => ({ ...chatStoreInitialState }))
        },
        updateValue(key, value) {
          set(state => ({ ...state, [key]: value }))
        },
      }),
      {
        name: '@ConexaPaciente:chat-storage',
        getStorage: () => sessionStorage,
      },
    ),
  ),
)
